import './Brand.css'

const Brand = () => {
    return (
        <img src="/img/logo.png" alt="Logo Tefric" />
    )
}

export default Brand